import type { ReactNode } from 'react';

import { Router as WouterRouter } from 'wouter';

type ProviderProps = {
  children: ReactNode;
};

const Provider = ({ children }: ProviderProps) => <WouterRouter>{children}</WouterRouter>;

export default Provider;
